import React from 'react';
import { useParams } from 'react-router-dom';
import { PropertyEditPage } from './PropertyEditPage';

export function PropertyEditPageWrapper() {
  const { propertyId } = useParams();
  return <PropertyEditPage propertyId={propertyId} />;
}
